var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#00C3CF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9974 2.66675C11.2174 2.66675 13.8307 5.28008 13.8307 8.50008C13.8307 11.7201 11.2174 14.3334 7.9974 14.3334C4.7774 14.3334 2.16406 11.7201 2.16406 8.50008C2.16406 5.28008 4.7774 2.66675 7.9974 2.66675ZM7.9974 13.1667C10.5757 13.1667 12.6641 11.0784 12.6641 8.50008C12.6641 5.92175 10.5757 3.83341 7.9974 3.83341C5.41906 3.83341 3.33073 5.92175 3.33073 8.50008C3.33073 11.0784 5.41906 13.1667 7.9974 13.1667ZM8.58073 8.50008V10.8334H7.41406V8.50008H5.66406L7.9974 6.16675L10.3307 8.50008H8.58073Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveIcon);
export default __webpack_public_path__ + "static/media/activeIcon.18e97465b0975c1a5623d4ab9ba0c264.svg";
export { ForwardRef as ReactComponent };